import {
  ApeironLinkButton,
  DEFAULT_ANIMATE_DURATION,
  NextImage,
  noForwardProps
} from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { IndexImageGridBlock } from '@src/types/pageBuilder'

const Container = styled(Box)`
  position: relative;
  width: 100%;
  padding: 16px;
`

const Image = styled(NextImage, noForwardProps)<{ __aspectRatio: string }>`
  aspect-ratio: ${props => props.__aspectRatio};
  width: 100%;
`

const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, minmax(338px, 338px));
  justify-content: center;
  gap: 16px;

  ${({ theme }) => theme.breakpoints.down('res1280')} {
    grid-template-columns: repeat(2, minmax(338px, 338px));
  }

  ${({ theme }) => theme.breakpoints.down('res768')} {
    grid-template-columns: repeat(1, minmax(338px, 338px));
  }
`

const LinkBox = styled(Box)`
  position: relative;
  width: 338px;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;
  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const Title = styled(Typography)`
  color: white;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  position: absolute;
  bottom: 12px;
  width: 100%;
  text-align: center;
  font-size: 20px;
`

const SmallText = styled(Typography)`
  color: white;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  top: 6px;
  width: 100%;
  text-align: center;
  font-size: 12px;
`

const Button = styled(ApeironLinkButton)`
  &.Mui-disabled {
    opacity: 1;
    filter: grayscale(90%);
  }
`

type Props = {
  layoutProps: IndexImageGridBlock['layoutProps']
  items: {
    disabled: boolean
    imageSrc: string
    link: string
    smallText: string
    title: string
  }[]
}

const IndexImageGridBlockView = ({ layoutProps, items }: Props) => {
  return (
    <Container>
      <Grid>
        {items.map((item, index) => {
          const key = `${item.title}-${index}`

          return (
            <Button disabled={item.disabled} key={key} url={item.link}>
              <LinkBox>
                <Image
                  src={item.imageSrc}
                  __aspectRatio={layoutProps.imageAspectRatio}
                />
                <Title>{item.title}</Title>
                {item.smallText && <SmallText>{item.smallText}</SmallText>}
              </LinkBox>
            </Button>
          )
        })}
      </Grid>
    </Container>
  )
}

export default IndexImageGridBlockView
